// ======================================================================
// FILE:
// src/modules/expense_management/claims/components/ExpenseClaimsTable.jsx
//
// MODULE:
// Expense Management
//
// FEATURE:
// Expense Claims Table
// ======================================================================

import React from "react";
import { useNavigate } from "react-router-dom";

export default function ExpenseClaimsTable({

  rows = [],

  loading = false,

}) {

  const navigate =
    useNavigate();

  async function handleDelete(row) {

    const ok = window.confirm(
      `Delete claim ${row.voucher_number}?`
    );

    if (!ok) {
      return;
    }

    // Delete API will be wired
    // from parent page.

  }

  function statusBadge(status) {

    switch (status) {

      case "DRAFT":
        return "secondary";

      case "SUBMITTED":
        return "primary";

      case "PENDING":
        return "warning";

      case "APPROVED":
        return "success";

      case "REJECTED":
        return "danger";

      case "PAID":
        return "info";

      default:
        return "secondary";

    }

  }

  return (

    <div className="card shadow-sm">

      <div className="card-header d-flex justify-content-between">

        <h5 className="mb-0">
          Expense Claims
        </h5>

        <span>
          {rows.length} Records
        </span>

      </div>

      <div className="card-body p-0">

        <div className="table-responsive">

          <table className="table table-hover mb-0">

            <thead
              className="table-light"
              style={{
                position: "sticky",
                top: 0,
                zIndex: 1,
              }}
            >

              <tr>

                <th>Claim No</th>
                <th>Date</th>
                <th>Employee</th>
                <th>Purpose</th>
                <th>Policy</th>
                <th>Items</th>

                <th className="text-end">
                  Amount
                </th>

                <th className="text-end">
                  Approved
                </th>

                <th>Status</th>
                <th>Approver</th>

                <th width="220">
                  Actions
                </th>

              </tr>

            </thead>

            <tbody>

              {loading && (

                <tr>

                  <td
                    colSpan="11"
                    className="text-center p-5"
                  >

                    <div
                      className="
                        spinner-border
                        text-primary
                      "
                    />

                  </td>

                </tr>

              )}

              {!loading &&
                rows.length === 0 && (

                <tr>

                  <td
                    colSpan="11"
                    className="text-center p-5"
                  >

                    No Expense Claims Found

                  </td>

                </tr>

              )}

              {!loading &&
                rows.map((row) => (

                <tr
                  key={row.expense_claim_id}
                >

                  <td>
                    {row.voucher_number}
                  </td>

                  <td>
                    {row.claim_date}
                  </td>

                  <td>
                    {row.employee_name}
                  </td>

                  <td>
                    {row.purpose}
                  </td>

                  <td>
                    {row.expense_policy_name}
                  </td>

                  <td>
                    {row.item_count}
                  </td>

                  <td className="text-end">
                    ₹ {Number(row.total_amount || 0).toFixed(2)}
                  </td>

                  <td className="text-end">
                    ₹ {Number(row.approved_amount || 0).toFixed(2)}
                  </td>

                  <td>

                    <span
                      className={`badge bg-${statusBadge(row.status)}`}
                    >
                      {row.status}
                    </span>

                  </td>

                  <td>
                    {row.current_approver}
                  </td>

                  <td>

                    <div
                      className="
                        d-flex
                        gap-1
                      "
                    >

                      <button
                        className="
                          btn
                          btn-sm
                          btn-outline-info
                        "
                        onClick={() =>
                          navigate(
                            `/expense-management/claims/${row.expense_claim_id}`
                          )
                        }
                      >
                        <i className="fas fa-eye" />
                      </button>

                      <button
                        className="
                          btn
                          btn-sm
                          btn-outline-primary
                        "
                        onClick={() =>
                          navigate(
                            `/expense-management/claims/edit/${row.expense_claim_id}`
                          )
                        }
                      >
                        <i className="fas fa-edit" />
                      </button>

                      <button
                        className="
                          btn
                          btn-sm
                          btn-outline-success
                        "
                      >
                        <i className="fas fa-paper-plane" />
                      </button>

                      <button
                        className="
                          btn
                          btn-sm
                          btn-danger
                        "
                        onClick={() =>
                          handleDelete(row)
                        }
                      >
                        <i className="fas fa-trash" />
                      </button>

                    </div>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>

  );

}